import { useMemo } from 'react';
import { useAppSelector } from '../../hooks';
import { calculatePrivileges, Privileges } from './privileges';

const useAccessControl = (): Privileges => {
  const idToken = useAppSelector((state) => state.user.idToken);
  const userFeatureFlags = useAppSelector((state) => state.user.featureFlags);

  const privileges = useMemo(
    () =>
      calculatePrivileges({
        idToken,
        userFeatureFlags,
      }),
    [idToken, userFeatureFlags]
  );

  return privileges;
};

export default useAccessControl;
